export default __webpack_public_path__ + "static/media/_DSC0133.935493ef.JPG";